module.exports = __webpack_public_path__ + "static/media/oaks3.fd81a0ec.jpg";